/* unplugin-vue-components disabled */import { render } from "./ImagePreviewer.vue?vue&type=template&id=1c5d186c&scoped=true"
import script from "./ImagePreviewer.vue?vue&type=script&lang=js"
export * from "./ImagePreviewer.vue?vue&type=script&lang=js"

import "./ImagePreviewer.vue?vue&type=style&index=0&id=1c5d186c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5d186c"]])

export default __exports__